export function nodeIsEmpty(node) {
  return node.textContent.trim() === ""
}